module.exports = __webpack_public_path__ + "img/ray_of_light.18284252.svg";